export class LatLngModel {
    public constructor(public lat: number, public lng: number) {
    }
}
